import http from '../../utils/http'; //封装的拦截器及错误处理的axios
import Qs from 'qs';

const meetingApi = {
  getBusinessConfig(params){
    return http({ method: 'get', url: 'business/config/list.jspx', params: params })
  },
  getMeeting(params) {
    return http({
      method: 'post',
      url: '/meeting/v_list.jspx',
      params: params
    })
  },
  getMeetingConfig(params) {
    return http({
      method: 'post',
      url: '/meeting/config/options.jspx',
      params: params
    })
  },
  submitSubscribe(reqdata){
    return http({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: 'post',
      url: '/meeting/count/submit.jspx',
      data: Qs.stringify(reqdata)
    })
  },
};
export default  meetingApi;



// WEBPACK FOOTER //
// ./src/api/meeting/index.js